module.exports = __webpack_public_path__ + "static/2026-eb9e2f7b3204748c1d2d13be0232f098.webp";